
<template>
  <router-view class="router-view" />
</template>

<script>
import { getToken } from "@/utils/token"
export default {
  name: "index"
};
// 货币和香港客户设置 - 未登录用户强制使用港币，已登录用户保持原有设置
const isLoggedIn = getToken();
if (!isLoggedIn) {
  // 未登录用户强制设置为香港客户和港币
  localStorage.setItem("isHKCustomer", 'true');
  localStorage.setItem("currency", 'HK＄');
} else {
  // 已登录用户：如果 isHKCustomer 不存在，设置默认值
  if (!localStorage.hasOwnProperty('isHKCustomer')) {
    localStorage.setItem("isHKCustomer", 'true');
  }
  // 已登录用户：如果 currency 不存在，设置默认值
  if (!localStorage.hasOwnProperty('currency')) {
    localStorage.setItem("currency", 'HK＄');
  }
}
// 是否切换过货币选择
if (!localStorage.hasOwnProperty('isCheckCurrency')) {
  localStorage.setItem("isCheckCurrency", 'false');
}
</script>

<style lang="scss" scoped>
/*切换样式出错处理*/
.router-view {
  width: 100%;
  height: 100%;
  -webkit-overflow-scrolling: touch;
}
</style>
